var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("\n\t\t\t"+_vm._s(_vm.unit.name)+"\n\t\t")]),_vm._v(" "),_c('v-divider')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }